import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericResponse } from 'src/app/api-interfaces';
import { AuthService } from 'src/app/auth/auth.service';
import { LogService } from 'src/app/shared/log.service';
import { IdentityService } from '../identity.service';
import { User } from '../user.model';
import { ConfigService } from 'src/app/config.service';


@Component({
  selector: 'app-personal-data',
  templateUrl: './personal-data.component.html',
  styleUrls: ['./personal-data.component.sass']
})
export class PersonalDataComponent implements OnInit {

  currentUser: User;
  logoutSso: string = `${ConfigService.settings.idpBaseUrl}/sso/session`
  constructor(
    private authService: AuthService,
    private logger: LogService,
    private identityService: IdentityService,
  ) { }

  ngOnInit(): void {
    this.currentUser = this.authService.getCurrentUser();
    this.authService.currentUserChanged.subscribe((data: User) => {
      this.currentUser = data;
    })
    this.logger.log("CURRENTUSER: ", this.currentUser)
  }

  getDisplaydocument_type(document_type: string): string {
    if (document_type === "IC") {
      return $localize`:Generic.IdentityCard|Carta d'identità@@Generic.IdentityCard:Carta d'identità`;
    } else if (document_type === "PS") {
      return $localize`:Generic.Passport|Passaporto@@Generic.Passport:Passaporto`;
    } else if (document_type === "DL") {
      return $localize`:Generic.DrivingLicense|Patente@@Generic.DrivingLicense:Patente`;
    } else {
      return "";
    }
  }

  private downloadBase64File(contentType: string, base64Data: string, fileName: string): void {
    const linkSource = `data:${contentType};base64,${base64Data}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
}

  downloadContract() {
    this.identityService.getContract().subscribe(
      (response: any) => {
        if (response["esito"] == "OK") {
          let resp: GenericResponse = response;
          console.log(resp.result);
          this.downloadBase64File('application/pdf', resp.result, 'contract.pdf');
          // let pdfWindow = window.open("")
          // pdfWindow.document.write(
          //   "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
          //   encodeURI(resp.result) + "'></iframe>"
          // )
        }
      },
      (err: Observable<never>) => { },
      () => { }
    );
  }

  onChangeEmailNotifications(isActive: boolean) {
    this.identityService.changeEmailNotifications()
      .subscribe(
        (response: GenericResponse) => {
          if (response["esito"] == "OK") {
            this.logger.log("Response OK");
          }
        },
      );
  }

}
